export default __webpack_public_path__ + "static/media/bg6.2cfa75e5.jpg";